import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-7"
}
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = { class: "col-span-6" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = { class: "col-span-6" }
const _hoisted_6 = { class: "col-span-6" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = { class: "col-span-6" }
const _hoisted_9 = { class: "col-span-6" }
const _hoisted_10 = { class: "col-span-6" }
const _hoisted_11 = { class: "col-span-6" }
const _hoisted_12 = { class: "col-span-6" }
const _hoisted_13 = { class: "col-span-6" }
const _hoisted_14 = { class: "col-span-6" }
const _hoisted_15 = { class: "col-span-6" }
const _hoisted_16 = { class: "col-span-6" }
const _hoisted_17 = { class: "col-span-6" }
const _hoisted_18 = { class: "col-span-6" }
const _hoisted_19 = { class: "col-span-6" }
const _hoisted_20 = { class: "col-span-6" }
const _hoisted_21 = { class: "col-span-6" }
const _hoisted_22 = { class: "col-span-6" }
const _hoisted_23 = { class: "col-span-6" }
const _hoisted_24 = { class: "col-span-6" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import PatientLayout from '../components/PatientLayout.vue';

import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import PageLoader from '@/components/PageLoader.vue';

import Patient from '@/classes/Patient';
import { useRoute } from 'vue-router';
import { ref, computed, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const route       = useRoute();
const loader      = ref(true)
const showError   = ref(false);
const errorMsg    = ref(false);
const form        = ref({})

const patientId = ref(route.params.id);

const canViewMedicalRecords = computed(() => {
    if(
        window.$hasPermission('view-corporate-patient-medical-records') ||
        window.$hasPermission('view-web-booking-medical-records') ||
        window.$hasPermission('view-contact-center-booking-medical-records') ||
        window.$hasPermission('view-patient-medical-records') ||
        window.$hasPermission('view-medical-records-in-offline')
    ) {
        return true;
    }

    return false;
});

onMounted(() => {
    loader.value = true;

    Patient.showPatient(patientId.value).then((response) => {
        loader.value = false;
        Object.assign(form.value, response.data)
    })
    .catch((err) => {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err.response.data.message;
    })
    
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Medical Record",
    "show-back": "",
    backUrl: `/accounts/patients`
  }, {
    default: _withCtx(() => [
      _createVNode(PatientLayout, { "patient-id": patientId.value }, {
        contents: _withCtx(() => [
          (canViewMedicalRecords.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(FormSection, null, {
                  title: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode(" Medical Record Information ", -1)
                  ]))]),
                  description: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode(" Relevant data and other details ", -1)
                  ]))]),
                  form: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(TextInput, {
                        modelValue: form.value.first_name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.first_name) = $event)),
                        disabled: "",
                        label: "First Name",
                        placeholder: "First Name"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(TextInput, {
                        modelValue: form.value.middle_name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.middle_name) = $event)),
                        disabled: "",
                        label: "Middle Name",
                        placeholder: "Middle Name"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(TextInput, {
                        modelValue: form.value.last_name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.last_name) = $event)),
                        disabled: "",
                        label: "Last Name",
                        placeholder: "Last Name"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(TextInput, {
                        modelValue: form.value.patient_id,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.patient_id) = $event)),
                        disabled: "",
                        label: "Patient ID",
                        placeholder: "Patient ID"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(TextInput, {
                        modelValue: form.value.hospital_no,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.hospital_no) = $event)),
                        disabled: "",
                        label: "Hospital ID",
                        placeholder: "Hospital ID"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(TextInput, {
                        modelValue: form.value.email_address,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.email_address) = $event)),
                        disabled: "",
                        label: "Email Address",
                        placeholder: "Email Address"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(TextInput, {
                        modelValue: form.value.sex,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.sex) = $event)),
                        disabled: "",
                        label: "Sex",
                        placeholder: "Sex"
                      }, null, 8, ["modelValue"])
                    ]),
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col-span-6" }, null, -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(TextInput, {
                        modelValue: form.value.nationality,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.nationality) = $event)),
                        disabled: "",
                        label: "Nationality",
                        placeholder: "Nationality"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(TextInput, {
                        modelValue: form.value.civil_status,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.civil_status) = $event)),
                        disabled: "",
                        label: "Civil Status",
                        placeholder: "Civil Status"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(TextInput, {
                        modelValue: form.value.telephone_number,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.telephone_number) = $event)),
                        disabled: "",
                        label: "Telephone Number",
                        placeholder: "Telephone Number"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(TextInput, {
                        modelValue: form.value.cellphone_number,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.cellphone_number) = $event)),
                        disabled: "",
                        label: "Cellphone Number",
                        placeholder: "Cellphone Number"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(TextInput, {
                        modelValue: form.value.province,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.province) = $event)),
                        disabled: "",
                        label: "Province",
                        placeholder: "Province"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(TextInput, {
                        modelValue: form.value.city,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.city) = $event)),
                        disabled: "",
                        label: "City/Municipality",
                        placeholder: "City/Municipality"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(TextInput, {
                        modelValue: form.value.barangay,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.barangay) = $event)),
                        disabled: "",
                        label: "Barangay",
                        placeholder: "Barangay"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(TextInput, {
                        modelValue: form.value.street,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.street) = $event)),
                        disabled: "",
                        label: "Street",
                        placeholder: "Street"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(TextInput, {
                        modelValue: form.value.building_number,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.building_number) = $event)),
                        disabled: "",
                        label: "No./Building",
                        placeholder: "No./Building"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(TextInput, {
                        modelValue: form.value.zip_code,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.zip_code) = $event)),
                        disabled: "",
                        label: "Zip Code",
                        placeholder: "Zip Code"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(TextInput, {
                        modelValue: form.value.philhealth_number,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.philhealth_number) = $event)),
                        disabled: "",
                        label: "PhilHealth Number",
                        placeholder: "PhilHealth Number"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(TextInput, {
                        modelValue: form.value.hmo_id,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.hmo_id) = $event)),
                        disabled: "",
                        label: "HMO",
                        placeholder: "HMO"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(TextInput, {
                        modelValue: form.value.contact_person_name,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.contact_person_name) = $event)),
                        disabled: "",
                        label: "Contact Person Name",
                        placeholder: "Contact Person Name"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(TextInput, {
                        modelValue: form.value.contact_person_relationship,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.value.contact_person_relationship) = $event)),
                        disabled: "",
                        label: "Contact Person Relationship",
                        placeholder: "Contact Person Relationship"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(TextInput, {
                        modelValue: form.value.cellphone_number,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.value.cellphone_number) = $event)),
                        disabled: "",
                        label: "Cellphone Number",
                        placeholder: "Cellphone Number"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(TextInput, {
                        modelValue: form.value.contact_person_email,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.value.contact_person_email) = $event)),
                        disabled: "",
                        label: "Email Address",
                        placeholder: "Email Address"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["patient-id"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})